import {Suspense} from "react";
import {Helmet} from "react-helmet-async";
import {FiPlus} from "react-icons/fi";
import {Link, useSearchParams} from "react-router";

import Button from "@/components/button/Button.tsx";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {Icon} from "@/components/icon/Icon.tsx";
import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {getListTitle} from "@/lib/hooks/useTable.utils.ts";
import {StatusPageTypeDisplayName} from "@/lib/types/statuspages.ts";
import {StatusPagesList} from "@/pages/statuspages/list/components/StatusPagesList.tsx";

export const ListAllStatusPages = () => {
  const {user} = useCurrentUserContext();
  const [searchParams] = useSearchParams();
  const statusPagesTitle = getListTitle(searchParams, "Status Pages", {
    key: "page_type",
    display: StatusPageTypeDisplayName,
    noun: "Pages",
  });

  return (
    <ContentContainer
      title={statusPagesTitle}
      actionsBar={
        user?.has_write_access && (
          <Button as={Link} size={"large"} to={"/statuspages/create"}>
            <Icon icon={FiPlus} /> Create Status Page
          </Button>
        )
      }
    >
      <Helmet>
        <title>Status Pages</title>
      </Helmet>
      <Suspense>
        <UpErrorBoundary>
          <StatusPagesList />
        </UpErrorBoundary>
      </Suspense>
    </ContentContainer>
  );
};
